{
  "ipp-light": {
    "hero": {
      "eyebrow": "Per piccoli produttori",
      "title": "Ottieni il capitale necessario per espandere il tuo portafoglio",
      "subtitle": "Incassa anticipatamente i profitti che i tuoi impianti attivi genereranno nei prossimi anni e utilizzali oggi per ampliare il tuo portafoglio, realizzando nuovi asset."
    },
    "benefits": {
      "eyebrow": "I vantaggi",
      "heading": "Una soluzione per i produttori in cerca di capitali per realizzare nuovi impianti",
      "items": [
        {
          "title": "Recupera il capitale bloccato nei tuoi asset attivi",
          "body": "La soluzione di DEC Energy ti permette di incassare subito fino al 60% dei profitti che l'impianto produrrà nei prossimi 10 anni."
        },
        {
          "title": "Finanzia la realizzazione di nuovi progetti",
          "body": "Riutilizzare immediatamente il capitale incassato (no debito) per finanziare lo sviluppo di nuovi progetti. Trovare l'equity per ottenere un finanziamento non è mai stato così veloce e conveniente."
        },
        {
          "title": "Applicabile su singoli impianti, a partire da 1 MWp",
          "body": "Il modello DEC Energy permette anche a produttori con impianti di dimensione ridotta di accrescere il proprio portafoglio di asset, diversamente da altre soluzioni che richiedono elevati volumi minimi"
        }
      ]
    },
    "stats": [
      {
        "target": "50-60",
        "suffix": "%",
        "label": "dei profitti futuri anticipati"
      },
      {
        "target": "2-3",
        "suffix": "x",
        "label": "impianti con lo stesso capitale proprio"
      },
      {
        "target": 1,
        "suffix": "MWp",
        "label": "di potenza minima"
      }
    ],
    "caseReal": {
      "heading": "DEC Energy in numeri tramite un caso reale",
      "sub": "Produttore e azienda manifatturiera stanno siglando un accordo su 5.24 MWp di asset fotovoltaico",
      "parties": {
        "producer": "asset fotovoltaico",
        "consumer": "manifatturiera"
      },
      "spec": {
        "label": "Scheda asset",
        "rows": [
          { "label": "Peak power", "value": "5'235 kWp" },
          { "label": "Route-to-market", "value": "FER X" },
          { "label": "Prezzo di vendita energia", "value": "63.97 €/MWh" },
          { "label": "OPEX", "value": "109'532 €/anno" },
          { "label": "Debt %", "value": "75%" }
        ],
        "total": {
          "value": "1'383'766 €",
          "label": "Net cash flow dei prossimi 10 anni"
        }
      },
      "terms": {
        "label": "Condizioni contrattuali applicate da DEC Energy",
        "items": [
          {
            "value": "710'000 €",
            "label": "Ammontare attualizzato e incassato subito"
          },
          {
            "value": "87.54%",
            "label": "Quota dei net cash flow effettivi da distribuire"
          },
          { "value": "10.64%", "label": "Tasso di sconto" }
        ]
      }
    },
    "ctaTitle": "Quanto capitale hai fermo nei tuoi impianti?"
  },
  "ipp": {
    "hero": {
      "eyebrow": "Per IPP",
      "title": "Fai derisking del tuo portafoglio, aumentando l'IRR",
      "subtitle": "Riduci l'esposizione al rischio del tuo portafoglio incassando oggi fino al 50-60% della cassa netta dei prossimi 10 anni. No debito aggiuntivo né vendita (di quote) dei tuoi impianti."
    },
    "benefits": {
      "eyebrow": "I vantaggi",
      "heading": "Una soluzione per gli IPP più ambiziosi e all'avanguardia",
      "items": [
        {
          "title": "Meglio di un mezzanino: conveniente, rapido e senza un repayment fisso",
          "body": "Il modello DEC Energy permette di attualizzare i profitti futuri degli impianti attivi. La soluzione è applicabile anche a singoli asset. Il tasso di sconto è performance-based e generalmente varia tra il 7% e il 13% a seconda dell'asset."
        },
        {
          "title": "Incassa subito e riduci i rischi di mercato e produzione",
          "body": "Contrattualizzando i tuoi impianti, ricevi subito fino al 50-60% della cassa netta generata teoricamente nei prossimi 10 anni. In questo modo ti assicuri immediatamente una parte dei ritorni, eliminando i rischi dei prezzi e produzione."
        },
        {
          "title": "Aumenta l'IRR della tua operazione senza investimenti aggiuntivi",
          "body": "Attualizzando i profitti, velocizzi il tempo di rientro di gran parte del capitale che altrimenti rimarrebbe bloccato in quel asset. In questo modo puoi allocare queste finanze per la realizzazione di nuovi progetti."
        }
      ]
    },
    "stats": [
      {
        "target": "50-60",
        "suffix": "%",
        "label": "della cassa netta futura anticipata"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "della proprietà mantenuta"
      },
      {
        "target": "7-13",
        "suffix": "%",
        "label": "di tasso di sconto"
      }
    ],
    "caseReal": {
      "heading": "DEC Energy in numeri tramite un caso reale",
      "sub": "IPP e industria chimica stanno siglando un accordo su 13.67 MWp di asset fotovoltaico",
      "parties": {
        "producer": "fotovoltaico",
        "consumer": "chimica"
      },
      "spec": {
        "label": "Scheda asset",
        "rows": [
          { "label": "Peak power totale", "value": "13.67 MWp" },
          { "label": "Route-to-market", "value": "FER X" },
          {
            "label": "Prezzo medio di vendita energia",
            "value": "65.78 €/MWh"
          },
          { "label": "OPEX", "value": "247'824 €/anno" },
          { "label": "Debt %", "value": "80%" }
        ],
        "total": {
          "value": "2'583'434 €",
          "label": "Net cash flow dei prossimi 10 anni"
        }
      },
      "terms": {
        "label": "Condizioni contrattuali applicate da DEC Energy",
        "items": [
          {
            "value": "1'370'000 €",
            "label": "Ammontare attualizzato e incassato subito"
          },
          {
            "value": "84.94%",
            "label": "Quota dei net cash flow effettivi da distribuire"
          },
          { "value": "9.43%", "label": "Tasso di sconto" }
        ]
      }
    },
    "ctaTitle": "Quanto capitale hai fermo negli asset in esercizio?"
  },
  "utility": {
    "hero": {
      "eyebrow": "Per Utility",
      "title": "Accelera la transizione mantenendo la proprietà degli impianti",
      "subtitle": "Ottieni il capitale necessario per accelerare la tua transizione energetica indipendente. Senza ricorrere al debito o alla vendita (di quote) dei tuoi impianti."
    },
    "benefits": {
      "eyebrow": "I vantaggi",
      "heading": "Una soluzione per le utility ambiziose e sostenibili",
      "items": [
        {
          "title": "Mantieni la piena proprietà dei tuoi impianti",
          "body": "Applica il modello DEC Energy sui tuoi impianti attivi per ricevere cassa anticipata senza cedere i tuoi asset."
        },
        {
          "title": "Aumenta la quota di produzione rinnovabile",
          "body": "Gestisci liberamente la produzione degli impianti contrattualizzati con DEC Energy e utilizza il capitale sbloccato per accrescere il tuo portafoglio di impianti rinnovabili."
        },
        {
          "title": "Migliora la tua Posizione Finanziaria Netta (PFN)",
          "body": "Il capitale ottenuto tramite DEC Energy non rappresenta un finanziamento e quindi ottimizza la Posizione Finanziaria Netta (PFN) della tua azienda."
        }
      ]
    },
    "stats": [
      {
        "target": "50-60",
        "suffix": "%",
        "label": "della cassa netta futura anticipata"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "della proprietà mantenuta"
      },
      {
        "target": "Nessun",
        "label": "debito aggiuntivo"
      }
    ],
    "caseReal": {
      "heading": "DEC Energy in numeri tramite un caso reale",
      "sub": "Utility e fonderia stanno siglando un accordo su 18.54 MWp di asset rinnovabile",
      "parties": {
        "producer": "fotovoltaico",
        "consumer": "fonderia"
      },
      "spec": {
        "label": "Scheda asset",
        "rows": [
          { "label": "Peak power totale", "value": "18.54 MWp" },
          { "label": "Route-to-market", "value": "FER 1" },
          {
            "label": "Prezzo medio di vendita energia",
            "value": "73.84 €/MWh"
          },
          { "label": "OPEX", "value": "432'024 €/anno" },
          { "label": "Debt %", "value": "80%" }
        ],
        "total": {
          "value": "3'968'166 €",
          "label": "Net cash flow dei prossimi 10 anni"
        }
      },
      "terms": {
        "label": "Condizioni contrattuali applicate da DEC Energy",
        "items": [
          {
            "value": "2'150'000 €",
            "label": "Ammontare attualizzato e incassato subito"
          },
          {
            "value": "87.62%",
            "label": "Quota dei net cash flow effettivi da distribuire"
          },
          { "value": "9.47%", "label": "Tasso di sconto" }
        ]
      }
    },
    "ctaTitle": "Quanta cassa potete sbloccare senza toccare la PFN?"
  }
}
